/**
 * 模型接口
 * @author： xuyd
 * @date：2024-05-02
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'
const serviceModule = context.sunflower

export default {

  /**
   * 获取所有组
   */
  selectGroupList: () => {
    return request.post(serviceModule + "/datasvc/api/group/select", {});
  },

  /**
   * 保存群组信息
   * @param params {JSON} {id, name, parentId}
   */
  saveGroup: (params) => {
    return request.post(serviceModule + "/datasvc/api/group/save", params);
  },

  /**
   * 上移组
   * @param id
   */
  upGroup: (id) => {
    return request.get(serviceModule + "/datasvc/api/group/up?id=" + id);
  },

  /**
   * 下移组
   * @param id
   */
  downGroup: (id) => {
    return request.get(serviceModule + "/datasvc/api/group/down?id=" + id);
  },

  /**
   * 删除组
   * @param id
   */
  deleteGroup: (id) => {
    return request.get(serviceModule + "/datasvc/api/group/delete?id=" + id);
  },


  /**
   * 检索列表
   */
  searchList: (params) => {
    return request.post(serviceModule + "/datasvc/api/design/search", params);
  },

  /**
   * 获取信息
   */
  getInfo: (id) => {
    let params = {id: id}
    return request.get(serviceModule + "/datasvc/api/design/info/get", {params});
  },

  /**
   * 保存信息
   */
  saveInfo: (params) => {
    return request.post(serviceModule + "/datasvc/api/design/info/save", params);
  },

  /**
   * 删除
   * @param id id
   */
  deleteInfo: (id) => {
    return request.get(serviceModule + "/datasvc/api/design/delete?id=" + id);
  },

  /**
   * 提交信息
   */
  submit: (params) => {
    return request.post(serviceModule + "/datasvc/api/design/info/submit", params);
  },

  /**
   * 获取脚本配置
   */
  getScriptConfig: (apiId) => {
    let params = {apiId: apiId}
    return request.get(serviceModule + "/datasvc/api/config/get", {params});
  },

  /**
   * 保存脚本配置
   */
  saveScript: (params) => {
    return request.post(serviceModule + "/datasvc/api/config/save", params);
  },

  /**
   * 执行SQL
   *
   * @param params
   */
  execute: (params) => {
    return request.post(serviceModule + "/datasvc/api/execute", params);
  },



  /**
   * 检索待审批列表
   */
  searchApproveList: (params) => {
    return request.post(serviceModule + "/datasvc/api/approve/search", params);
  },

  /**
   * 审批通过
   *
   * @param params
   */
  approveResolve: (params) => {
    return request.post(serviceModule + "/datasvc/api/approve/resolve", params);
  },
  /**
   * 审批驳回
   *
   * @param params
   */
  approveReject: (params) => {
    return request.post(serviceModule + "/datasvc/api/approve/reject", params);
  },

  /**
   * 审批通过并上线(模拟)
   *
   * @param params
   */
  approveResolveAndOnline: (params) => {
    return request.post(serviceModule + "/datasvc/api/approve/resolveAndOnline", params);
  },

  /**
   * Api数据源选择（下拉）
   *
   * @param search
   */
  queryApiDs: (search) => {
    return request.get(serviceModule + "/datasvc/api/query?search=" + encodeURIComponent(search));
  },

  /**
   * Api执行
   * @param apiName
   * @param params
   */
  runApi: (apiName, params) => {
    return request.post(`/open/api/${apiName}`, params);
  },


}
